import React from 'react';

const Donate = () => {
  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto', textAlign: 'left' }}>
      <h2>DONATION FOR GREEN EMMUNITY</h2>
      <p>Bank: IOB,</p>
      <p>A/c No: 311901000000567</p>
      <p>IFSCode: IOBA0003119</p>
      <p>Exampted 80G of IT Act 1961 Vide L.No: ITO (Tech) 80G-85/11-12/10340-42, Dt: 03.02.2012, PAN NO: AAATK9182B, TAN No: BBNKO1230F</p>
      <p>Dear Visitor it is a Natural "AROGYA BANAM" Hill & Spring Scenerio, Oxigen Space, Spritual Healthy Envieoment and realy ancient Ashram surrounding. Here need of "SHRAMADAAN"</p>
      <p>Contact No: 0680-2490055 (Ramesh Ch. Panda)</p>
    </div>
  );
};

export default Donate;
